/**
 * DO NOT MODIFY THIS FILE.
 * This will replace the `local-configuration-overrides.ts` file when building the prod bundles for the docker images.
 * (check `/clean_local_config.js` and `npm run build:ssr:ci`)
 */
export const localConfigOverrides = {} as {
    [key: string]: any;
};
